import { FC, ReactNode } from 'react';

import { PopoverContentProps } from '@reactour/tour';

import Button from '../Button';

interface PROPS extends PopoverContentProps {
  content: string | ReactNode;
  type?: string;
  hideNote?: boolean;
  endTour?: boolean;
}

const Content: FC<PROPS> = ({
  currentStep,
  content,
  type,
  setCurrentStep,
  hideNote,
  endTour = false,
}) => {
  const buttonAction = () => {
    setCurrentStep(currentStep + 1);
  };
  const handleEndTour = () => {
    window.location.href = '/';
  };
  return (
    <div className="text-[#18181B]">
      <p>{content}</p>
      {!hideNote && (
        <p className="text-xs text-content mt-4 font-normal">
          Note: For this walkthrough, we have pre-filled the {type} form for
          you.
        </p>
      )}
      <div className="flex justify-end pt-5">
        {!endTour ? (
          <Button onClick={buttonAction} label="NEXT" />
        ) : (
          <Button onClick={handleEndTour} label="END TOUR" />
        )}
      </div>
    </div>
  );
};

export default Content;
